import { render, staticRenderFns } from "./CAxAFSMxPsychomotorPage.vue?vue&type=template&id=026b15d6"
import script from "./CAxAFSMxPsychomotorPage.vue?vue&type=script&lang=js"
export * from "./CAxAFSMxPsychomotorPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAFSMxPsychomotorPage.vue?vue&type=style&index=0&id=026b15d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports